(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('PERMISSIONS', {
            PERM_USER_CAN_CHANGE_ORG_UNIT_DURING_ADD_DOCUMENT: 'PERM_USER_CAN_CHANGE_ORG_UNIT_DURING_ADD_DOCUMENT'
        });
})();
